export const getCurrencyData = (currencyData) => {
  return {
    type: 'getCurrency',
    payload: currencyData,
  }
}

export const createCurrency = (data) => {
  return {
    type: 'createCurrency',
    payload: data,
  }
}

export const updateCurrencyData = (currencyData) => {
  return {
    type: 'updateCurrency',
    payload: currencyData,
  }
}
